// extracted by mini-css-extract-plugin
export default {"sourceAccount":"TransInter_sourceAccount__hfAS7","infoTrans":"TransInter_infoTrans__lmwns","infoSource":"TransInter_infoSource__aBmbb"};